const formatInput = (event,name,form) => {
    let formObj = {
      ...form,
      [name]: event.target.value.trim(),
    };
    return formObj;
  } 
export default formatInput;
